import { Navigate, useLocation } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import Landing from "src/pages/Landing";
import { useNavSignals } from "src/hooks/useNavSignals";
import { homePathFor } from "src/utils/nav/navState";

// `/` is a role-aware home. Anonymous users render Landing immediately (no
// probe wait — protects marketing paint). Authenticated users wait briefly on
// the shared nav probe, then redirect (operator -> /tarjouspyynnot,
// customer-with-orders -> /valut) or render Landing. Fails open to Landing.
export default function HomeResolver() {
  const { role, loading, hasActiveOrders, operatorNeedsActivation } = useNavSignals();
  const location = useLocation();

  // Logo click forces the marketing Landing even for authed users (App.jsx
  // passes state={{ stay: true }}); skips the role-aware redirect below.
  if (location.state?.stay) return <Landing />;

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  const target = homePathFor({ role, hasActiveOrders, operatorNeedsActivation });
  if (target !== "/") return <Navigate to={target} replace />;
  return <Landing />;
}
